import React from 'react'
import { Contract } from '../../../../types/contract'
import { ModuleField } from '../../../../types/custom-fields/module-field'
import { DonorUserInfo } from '../../../../types/donor-user'
import { InlineFieldInput } from '../../fields/inputs/CustomFieldInlineInput'
import { FieldBlock } from '../../fields/FieldBlock'
import { CustomFieldInput } from '../../fields/inputs/CustomFieldInput'
import { translations } from '../../../../utils/translations/translations-manager'
import { TextField } from '../../fields/TextField'
import { SupportedFieldTypes } from '../../../../types/custom-fields/custom-field-type'

const UserView: React.FC<{
  contract: Contract
  fields: ModuleField[]
  errors?: Record<string, string>
  editMode?: boolean
  onChange: (value: DonorUserInfo) => void
  save: (key: string) => Promise<void>
}> = ({ contract, fields, errors, editMode = false, onChange, save }) => {
  // TODO: Add loader while loading fields

  return (
    <div className="user-data h-fit flex flex-col gap-3 p-5 bg-cents-white rounded-2xl">
      <div className="user-data-title text-xl lg:text-[22px] text-cents-purple font-semibold">{translations.texts.donor_info.toString()}</div>
      <div className="user-data-fields grid lg:grid-cols-2 2xl:grid-cols-3 gap-3 md:gap-y-5 md:gap-x-10">
        {fields?.map(moduleField => (
          <FieldBlock key={moduleField._id} label={translations.getText(moduleField.label) ?? ''} className="border-b border-cents-black/20 gap-0">
            <div className="mt-2">
              {SupportedFieldTypes.includes(moduleField.type) ? (
                editMode ? (
                  <CustomFieldInput
                    value={contract[moduleField.name] as string | number | boolean | undefined}
                    onChange={value => onChange({ [moduleField.name]: value })}
                    type={moduleField.type}
                  />
                ) : (
                  <InlineFieldInput
                    value={contract[moduleField.name] as string | number | boolean | undefined}
                    onChange={value => onChange({ [moduleField.name]: value })}
                    type={moduleField.type}
                    save={() => save(moduleField.name)}
                  />
                )
              ) : (
                <TextField value={contract[moduleField.name]?.toString()} />
              )}
            </div>
            <span className="text-red-500 h-4 italic text-sm">{errors?.[moduleField.name]}</span>
          </FieldBlock>
        ))}
      </div>
    </div>
  )
}

export default UserView
